<template>
<div>
  <loading 
        :active.sync="load" 
        :is-full-page="true"
        color="green"
        ></loading>
    <billingdashboard
     v-if="!load"
     :billingData="allBilling"
      :packagedata="packageData"
      :networkdata="networkData"
      :networkspeeds="networkSpeeds"
      :ispdata="ispData"
      :startdate="startDay"
      :enddate="endDay"
      :activeaccounts="activeAccounts"
      :unitspassed="unitsPassed"
      :unitsconnected="unitsConnected"
      :provisionedconnectionscount="provisionedConnections"
    ></billingdashboard>
    </div>
</template>

<script>
import Api from "@/services/Api";
import BillingDashBoard from '@/components/BillingDashboard.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    components:{
        billingdashboard: BillingDashBoard,
         loading: Loading,
    },
    data(){
        return {
          load: true,
            totalRevenue: [],
            networkData: [],
            ispData: [],
            packageData: [],
            setDate: new Date(),
            startDate: new Date(),
            endDate: new Date(),
            startDay: new Date(),
            endDay: new Date(),
            billedDays: 0,
            daysInCurrentMonth: 0,
            unitsPassed: {},
            unitsConnected: {},
            provisionedConnections: {},
            activeAccounts: {}
        }
    },
    async created(){
        let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/billingDashboard'})
      if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize()
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
        
      },
      methods: {
        async initialize(){
        await this.billingData()
        await this.getLocationCount();
        await this.getConnectedLocationCount();
        await this.getProvisionedAccountsCount();
        await this.getActiveAccounts();
        // if(this.$store.state.currentOrg.org.oneDevicePolicy){
        // await this.getActiveAccounts();
        // } else {
        // await this.getActiveAccountsTwoDevice();
        // }
        this.load=false
      },

       async getLocationCount(){
        await Api().get('/locations/active/count')
        .then(response=>{
            this.unitsPassed = response.data
        })
    },
    async getConnectedLocationCount(){
        await Api().get('/locations/connected/count')
        .then(response=>{
            this.unitsConnected = response.data
        })
    },
    async getProvisionedAccountsCount(){
        await Api().get('/deviceBridges/activeCount')
          .then(response=>{
              this.provisionedConnections = response.data
          })
    },
    async getActiveAccounts() {
      await Api()
        .get("/serviceAccounts/active/count")
        .then(response => {
          this.activeAccounts = response.data;
        });
    },
    async getActiveAccountsTwoDevice() {
      await Api()
        .get("/serviceAccounts/active/count/twoDevice")
        .then(response => {
          this.activeAccounts = response.data;
        });
    },

      async getServiceAccountBySpeed() {
      // await Api()
      //   .get("/serviceAccounts/allActive/speed")
      //   .then(async response => {
          let speedProfiles = [
            ...new Set(
              this.allBilling.map(
                item => item.packagesIsp.packagesFno.speedProfileId
              )
            )
          ];
          let ispArray = [
            ...new Set(
              this.allBilling.map(
                item => item.packagesIsp.customerOrganisation.id
              )
            )
          ];
          let networks = [
            ...new Set(
              this.allBilling.map(
                item => item.location.locationNetworkId
              )
            )
          ];
          this.ispData = []
          await ispArray.map(e=>{
              let isp = this.allBilling.find(x=>x.packagesIsp.customerOrganisation.id===e)
              this.ispData.push({
                  id: e,
                  customerOrganisation: isp.packagesIsp.customerOrganisation,
                  count: this.allBilling.filter(f=>f.packagesIsp.customerOrganisation.id === e).reduce((a, b) => +a + +b.prorata, 0)
              })
          })
          this.ispData.sort((a, b) =>
            a.count < b.count
              ? 1
              : b.count < a.count
              ? -1
              : 0
          );
          this.packageData = [];
          await speedProfiles.map(x => {
            let find = this.allBilling.find(
              z => z.packagesIsp.packagesFno.speedProfile.id === x
            );
            this.packageData.push({
              id: x,
              speedProfile: find.packagesIsp.packagesFno.speedProfile,
              colour: find.packagesIsp.packagesFno.speedProfile.colour,
              count: this.allBilling.filter(
                y => y.packagesIsp.packagesFno.speedProfileId === x
              ).reduce((a, b) => +a + +b.prorata, 0)
            });
          });
          this.packageData.sort((a, b) =>
            a.speedProfile.downloadMbps > b.speedProfile.downloadMbps
              ? 1
              : b.speedProfile.downloadMbps > a.speedProfile.downloadMbps
              ? -1
              : 0
          );

          this.networkData = []

          await networks.map(x => {
            let find = this.allBilling.find(
              z => z.location.locationNetwork.id === x
            );
            this.networkData.push({
              id: x,
              locationNetwork: find.location.locationNetwork,
              count: this.allBilling.filter(
                y => y.location.locationNetworkId === x
              ).length
            });
          });
          
          this.networkData.sort((a, b) =>
            a.count < b.count
              ? 1
              : b.count < a.count
              ? -1
              : 0
          );

          this.networkSpeeds = []

          for (let a=0; a<this.packageData.length;a++){
              let obj = {
                  speedProfileId: this.packageData[a].speedProfile.id,
                  label: this.packageData[a].speedProfile.name,
                  colour: this.packageData[a].speedProfile.colour,
                  backgroundColor: '',
                  borderColor: '',
                  borderWidth: 1,
                  data: []
              }
              this.networkSpeeds.push(obj)
          }

          for (let b=0; b<this.networkData.length;b++){
              for (let c=0; c<this.networkSpeeds.length;c++){
                  let count = await this.allBilling.filter(d=>d.location.locationNetworkId===this.networkData[b].locationNetwork.id&&
                  d.packagesIsp.packagesFno.speedProfileId===this.networkSpeeds[c].speedProfileId).reduce((a, b) => +a + +b.prorata, 0)
                  await this.networkSpeeds[c].data.push(count)
              }
          }
    },

    async billingData(){
      this.setDate = new Date();
          let initialDate = new Date(this.setDate);
          let selectedDate = new Date(
            initialDate.getFullYear(),
            initialDate.getMonth(),
            25
          );

          this.startDay = new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth() - 1,
            26
          ),
          this.startDay.setHours(0,0,0,0)
            this.endDay = new Date(
              this.startDay.getFullYear(),
              this.startDay.getMonth() + 1,
              25
            );
          this.endDay.setHours(0,0,0,0)


          let date = new Date(
            this.startDay.getFullYear(),
            this.startDay.getMonth(),
            0
          );
          this.layerTwoBilling = [];
          let start = this.startDay;
          let end = this.endDay;
          // for(let i = 0;i<this.organisations.length;i++){
          //   let bill = this.organisations[i].layerTwo.filter(function(el){
          //     return new Date(el.bill_dateto)>new Date(start)&&
          //           new Date(el.bill_dateto)<new Date(end)
          //   })
          //   if(bill.length>0){
          //     await this.layerTwoBilling.push({organisationId: this.organisations[i].id, xeroContactId: this.organisations[i].xeroContactId, layerTwoUsage: (Math.round(bill[0].rate_95th/10000)/100), layerTwoRate: this.organisations[i].layerTwoRate, from: bill[0].bill_datefrom, to: bill[0].bill_dateto})
          //   }
          // }
          await Api()
            .get("/serviceAccounts/billing/oneDevice", {
              params: {
                billingStart: this.startDay,
                billingEnd: this.endDay
              }
            })
            .then(async response => {
              this.allBilling = response.data;
            })
          // await Api()
          //   .get("/serviceAccounts/billing", {
          //     params: {
          //       billingDate: new Date()
          //     }
          //   })
          //   .then(async response => {
            for (let i = 0; i < this.allBilling.length; i++) {
                //   Recurring Billing
                this.allBilling[i].prorata = await this.calcuateRecurringBills(
                  this.allBilling[i]
                );
                this.allBilling[i].layerTwoProrata = this.allBilling[i].packagesIsp.packagesFno.layerTwoPortion*(this.allBilling[i].prorata/this.allBilling[i].packagesIsp.packagesFno.packageBasePrice)
                // Once Off Activations
                

                if (
                  new Date(this.allBilling[i].fnoActivationDate) <=
                    new Date(this.endDay) &&
                  new Date(this.allBilling[i].fnoActivationDate) >=
                    new Date(this.startDay) &&
                  this.allBilling[i].isChange === false
                ) {
                  if(this.allBilling[i].packagesIsp.packagesFno.setupFee&&this.allBilling[i].packagesIsp.packagesFno.setupFee!=0){
                    this.allBilling[i].onceOff = this.allBilling[i].packagesIsp.packagesFno.setupFee
                  } else {
                    this.allBilling[i].onceOff = this.allBilling[
                    i
                  ].location.locationNetwork.activationFeeAmount;
                  }
                  
                } else if (
                  new Date(this.allBilling[i].fnoActivationDate) ===
                    new Date(this.endDay) ||
                  new Date(this.allBilling[i].fnoActivationDate) ===
                    new Date(this.startDay)
                ) {
                  if(this.allBilling[i].packagesIsp.packagesFno.setupFee&&this.allBilling[i].packagesIsp.packagesFno.setupFee!=0){
                    this.allBilling[i].onceOff = this.allBilling[i].packagesIsp.packagesFno.setupFee
                  } else {
                      this.allBilling[i].onceOff = this.allBilling[
                    i
                  ].location.locationNetwork.activationFeeAmount;
                  }
                  
                } else {
                  
                  this.allBilling[i].onceOff = 0;
                }
                // Start Date
                if (
                  new Date(this.allBilling[i].fnoActivationDate) >=
                  new Date(this.startDay)
                ) {
                  new Date(this.allBilling[i].startDate = this.allBilling[
                    i
                  ].fnoActivationDate);
                } else {
                  this.allBilling[i].startDate = this.startDay;
                }
                // End Date
                if (
                  this.allBilling[i].fnoDeactivationDate !== null &&
                  this.allBilling[i].ispDeactivationDate === null &&
                  new Date(this.allBilling[i].fnoDeactivationDate) <=
                    new Date(this.endDay) &&
                  new Date(this.allBilling[i].fnoDeactivationDate) >=
                    new Date(this.startDay)
                ) {
                  new Date(this.allBilling[i].endDate = this.allBilling[
                    i
                  ].fnoDeactivationDate);
                } else if (
                  this.allBilling[i].fnoDeactivationDate === null &&
                  this.allBilling[i].ispDeactivationDate !== null &&
                  new Date(this.allBilling[i].ispDeactivationDate) <=
                    new Date(this.endDay) &&
                  new Date(this.allBilling[i].ispDeactivationDate) >=
                    new Date(this.startDay)
                ) {
                  this.allBilling[i].endDate = this.allBilling[
                    i
                  ].ispDeactivationDate;
                } else if (
                  this.allBilling[i].fnoDeactivationDate !== null &&
                  this.allBilling[i].ispDeactivationDate !== null &&
                  new Date(this.allBilling[i].fnoDeactivationDate) >=
                    new Date(this.allBilling[i].ispDeactivationDate) &&
                    new Date(this.allBilling[i].fnoDeactivationDate) <=
                      new Date(this.endDay) &&
                    new Date(this.allBilling[i].fnoDeactivationDate) >=
                      new Date(this.startDay)
                ) {
                  this.allBilling[i].endDate = this.allBilling[
                    i
                  ].fnoDeactivationDate;
                } else if (
                  this.allBilling[i].fnoDeactivationDate !== null &&
                  this.allBilling[i].ispDeactivationDate !== null &&
                  new Date(this.allBilling[i].fnoDeactivationDate) <=
                    new Date(this.allBilling[i].ispDeactivationDate) &&
                    new Date(this.allBilling[i].ispDeactivationDate) <=
                      new Date(this.endDay) &&
                    new Date(this.allBilling[i].ispDeactivationDate) >=
                      new Date(this.startDay)
                ) {
                  this.allBilling[i].endDate = this.allBilling[
                    i
                  ].ispDeactivationDate;
                } else {
                  this.allBilling[i].endDate = this.endDay;
                }
              }
          this.key += 1;
                    await this.getServiceAccountBySpeed()
        },

       async calcuateRecurringBills(item) {
      var one_day = 1000 * 60 * 60 * 24
      // this.getStart(item.fnoActivationDate, item.ispActivationDate);
      if (new Date(item.fnoActivationDate) >= new Date(this.startDay)) {
        this.startDate = new Date(item.fnoActivationDate);
      } else {
        this.startDate = new Date(this.startDay);
      }
      if (
        item.fnoDeactivationDate === null
      ) {
        this.endDate = new Date(this.endDay);
      } else if (
        item.fnoDeactivationDate !== null &&
        new Date(item.fnoDeactivationDate) <= new Date(this.endDay) &&
        new Date(item.fnoDeactivationDate) >= new Date(this.startDay)
      ) {
        this.endDate = new Date(item.fnoDeactivationDate);
      }  else if (
        item.fnoDeactivationDate !== null
      ) {
        if (
          new Date(item.fnoDeactivationDate) > new Date(this.endDay)
        ) {
          this.endDate = new Date(this.endDay);
        }
      }
      let setDate = new Date(this.setDate);
      this.daysInCurrentMonth = Math.round(
        Math.abs(this.endDay.getTime() - this.startDay.getTime()) / one_day
      );
      
      // this.startDate = new Date(this.startDate);
      this.startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate())
      this.startDate.setHours(0,0,0,0);
      this.endDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate())
      this.endDate.setHours(23,59,59,0);
      let billedAmount = item.packagesIsp.packagesFno.packageBasePrice;
      this.billedDays = Math.round(
        (Math.abs(this.endDate.getTime() - this.startDate.getTime()) / one_day)
      );
      if(this.billedDays>this.daysInCurrentMonth){
        this.billedDays = this.daysInCurrentMonth
      }
      if (
        item.location.locationNetwork.lineRentalIncluded &&
        item.packagesIsp.packagesFno.packagesFnoCat.packageCatType ===
          "Residential"
      ) {
        billedAmount =
          billedAmount -
          item.location.locationNetwork.residentialLineRentalValue;
      } else if (
        item.location.locationNetwork.lineRentalIncluded &&
        item.packagesIsp.packagesFno.packagesFnoCat.packageCatType ===
          "Business"
      ) {
        billedAmount =
          billedAmount - item.location.locationNetwork.businessLineRentalValue;
      }
      return (
        Math.round(
          (this.billedDays / this.daysInCurrentMonth) * billedAmount * 100
        ) / 100
      );
    }
      },

      
    
}
</script>
